import { useEffect } from "react";
import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import AboutQHHT from "@/pages/AboutQHHT";
import AboutIsabelle from "@/pages/AboutIsabelle";
import WhatToExpect from "@/pages/WhatToExpect";
import Volunteer from "@/pages/Volunteer";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Testimonials from "@/pages/Testimonials";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
              <ScrollToTop />
              <Seo />
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about-qhht" element={<AboutQHHT />} />
                <Route path="/about-isabelle" element={<AboutIsabelle />} />
                <Route path="/what-to-expect" element={<WhatToExpect />} />
                <Route path="/volunteer" element={<Volunteer />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book" element={<Book />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              </Routes>
              <Footer />
              <Toaster position="top-center" richColors />
            </ReactLenis>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
